__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@helios/shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@helios/shared-domain/stores", "1.0.1", () => (() => (__webpack_require__(2434))), 1);
			register("@helios/shared-domain", "1.0.1", () => (__webpack_require__.e(290).then(() => (() => (__webpack_require__(2290))))));
			register("@helios/ui-components", "1.0.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(458), __webpack_require__.e(105)]).then(() => (() => (__webpack_require__(5458))))));
			register("@tanstack/match-sorter-utils", "8.19.4", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(2868))))));
			register("@tanstack/react-query", "5.90.19", () => (() => (__webpack_require__(4553))), 1);
			register("@tanstack/react-table", "8.21.3", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(5100))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(3144))), 1);
			register("react-router-dom", "7.18.2", () => (() => (__webpack_require__(6529))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(4041))), 1);
			register("zustand", "5.0.10", () => (() => (__webpack_require__(1087))), 1);
			initExternal(8228);
			initExternal(6015);
			initExternal(7083);
			initExternal(6004);
			initExternal(2347);
			initExternal(8202);
			initExternal(1591);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};